import React from "react";
import { Card } from "antd";
import { Timeline } from "antd";
import { EnvironmentOutlined, FlagOutlined } from "@ant-design/icons";

const TripRoute = ({ reportingAddress, dropAddress }) => {
  return (
    <Card
      style={{
        width: "100%",
        borderRadius: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        padding: "16px",
        marginBottom: "3vh",
        marginTop: "3vh",
        backgroundColor: "var(--background-light)",
      }}
    >
      <Timeline mode="left">
        <Timeline.Item
          dot={<EnvironmentOutlined style={{ fontSize: "var(--font-size-sm)", color: "#52c41a" }} />}
        >
          <strong style={{ fontSize: "var(--font-size-xs)" }}>Reporting Address</strong>
          <p style={{ fontSize: "var(--font-size-2xs)", color: "#666" }}>{reportingAddress}</p>
        </Timeline.Item>

        <Timeline.Item
          dot={<FlagOutlined style={{ fontSize: "var(--font-size-sm)", color: "#f5222d" }} />}
        >
          <strong style={{ fontSize: "var(--font-size-xs)" }}>Drop Address</strong>
          <p style={{ fontSize: "var(--font-size-2xs)", color: "#666" }}>{dropAddress}</p>
        </Timeline.Item>
      </Timeline>
    </Card>
  );
};

export default TripRoute;
